import { getSigninUrl } from './utils';

// After a successful oauth, a user should not automatically be taken back to these routes
export const SHOULD_NOT_REDIRECT = ['/signin', '/signout', '/error', '/local-dev/signin'];

export function getAutomaticRedirectPath(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0];

  return SHOULD_NOT_REDIRECT.includes(pathname) ? '/' : path;
}

export function oauthRedirect(redirectPath?: string, replace = false): void {
  // If a redirectUrl is specified, it should take precedence
  // Otherwise, redirect the user back to the URL they originally requested whenever possible
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const automaticRedirectPath = getAutomaticRedirectPath(currentPath);
  const basePath = redirectPath ?? automaticRedirectPath;

  if (process.env.ENABLE_LOCAL_DEV_SIGNIN_SCREEN) {
    window.location.assign(`/local-dev/signin?redirectUrl=${encodeURIComponent(basePath)}`);
    return;
  }

  const url = new URL(getSigninUrl(basePath));

  if (replace) {
    window.location.replace(url);
  } else {
    window.location.assign(url);
  }
}
